import { orchestrator } from 'satcheljs';
import {
    initializeCalendarsCacheInStore,
    calendarCacheInitialized,
    calendarCacheInitializeFailed,
} from '../actions/publicActions';
import { initializeCalendarsCache } from '../actions/publicActions';
import { getCalendarsService } from '../services/getCalendarsService';
import { convertToCalendarCacheStoreData } from '../utils/convertToCalendarCacheStoreData';
import {
    calendarCacheInitializedInternal,
    addLoadingScenario,
    setLoadState,
    clearLoadingScenarios,
    calendarCacheInitializeFailedInternal,
} from '../actions/internalActions';
import {
    getCacheLoadState,
    getLoadingScenarios,
} from '../selectors/calendarCacheInitializationStateSelectors';
import { CalendarCacheInitializationLoadState } from '../store/schema/CalendarCacheInitializationState';
import { assertNever } from 'owa-assert';
import { trace } from 'owa-trace';
import { getUserMailboxInfo } from 'owa-client-ids';
import { getOWAConnectedAccounts } from 'owa-accounts-store';

export const initializeCalendarsCacheOrchestrator = orchestrator(
    initializeCalendarsCache,
    async actionMessage => {
        let mailboxId = getUserMailboxInfo().mailboxId;
        if (
            actionMessage.calendarCacheScenarioId == 'CalendarModule' &&
            !actionMessage.isPrimaryAccount
        ) {
            mailboxId = null;
            // For CalendarModule scenario - non primary account case, get the first account for which the load state is "not loaded" and process that account
            let accounts = getOWAConnectedAccounts();
            for (const account of accounts) {
                if (
                    getCacheLoadState(account.mailboxId) ==
                    CalendarCacheInitializationLoadState.NotLoaded
                ) {
                    mailboxId = account.mailboxId;
                    break;
                }
            }
        }
        if (mailboxId) {
            addLoadingScenario(actionMessage.calendarCacheScenarioId);
            let loadState = getCacheLoadState(mailboxId);
            switch (loadState) {
                case CalendarCacheInitializationLoadState.NotLoaded:
                    setLoadState(CalendarCacheInitializationLoadState.Loading);
                    const response = await getCalendarsService(mailboxId);
                    if (response !== null && response.WasSuccessful) {
                        const cacheData = convertToCalendarCacheStoreData(
                            response.CalendarGroups,
                            response.CalendarFolders,
                            mailboxId
                        );
                        await initializeCalendarsCacheInStore(
                            cacheData.defaultCalendar,
                            cacheData.calendarEntryMapping,
                            cacheData.calendarFolderMapping,
                            cacheData.calendarGroupMapping,
                            cacheData.folderIdMapping,
                            cacheData.calendarIdToChangeKeyMapping
                        );
                        await calendarCacheInitializedInternal(mailboxId);
                    } else {
                        calendarCacheInitializeFailedInternal();
                        trace.error(
                            '[getCalendarFoldersFromServer] Failed to load calendars from server'
                        );
                    }
                    break;
                case CalendarCacheInitializationLoadState.Loaded:
                    calendarCacheInitializedInternal(mailboxId);
                    break;
                case CalendarCacheInitializationLoadState.Loading:
                    break;
                default:
                    assertNever(loadState);
                    break;
            }
        }
    }
);

orchestrator(calendarCacheInitializedInternal, async actionMessage => {
    setLoadState(CalendarCacheInitializationLoadState.Loaded, actionMessage.mailboxId);
    await Promise.all(
        getLoadingScenarios().map(
            async scenario => await calendarCacheInitialized(scenario, actionMessage.mailboxId)
        )
    );
    clearLoadingScenarios();
});

orchestrator(calendarCacheInitializeFailedInternal, actionMessage => {
    setLoadState(CalendarCacheInitializationLoadState.NotLoaded, actionMessage.mailboxId);
    getLoadingScenarios().forEach(scenario =>
        calendarCacheInitializeFailed(scenario, actionMessage.mailboxId)
    );
    clearLoadingScenarios();
});
